var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    { '--comments': _vm.isCommentThread, '--feeds': _vm.isFeed },
    'chat-block p-relative '
  ],style:({ padding: _vm.blockPadding })},[(_vm.isBuilderContext())?[_c('block-placeholder',{attrs:{"icon":_vm.blockIcon,"text":_vm.blockText}})]:(_vm.messageThreadId)?[_c('message-thread',{attrs:{"message-thread-id":_vm.messageThreadId,"is-comment-thread":_vm.isCommentThread,"is-feed":_vm.isFeed,"page-id":_vm.pageId,"placeholder":_vm.isCommentThread
          ? _vm.$t('components.blocks.chatBlock.addComment')
          : _vm.$t('components.blocks.chatBlock.writeSomething')}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }